<template>
    <div ref="plot">
    </div>
</template>

<script>
import * as d3 from "d3";
import _ from "lodash";
import { drawVerticalLines } from '../util';
export default {
    props: ['input', 'meta', 'lineCoordinates'],
    watch: {
        input() {
            this.render();
        },
        // Opted for re-rendering the entire component for readability and simplicity. 
        // This approach needs to be reviewed and approved by Ivan for potential performance considerations.
        lineCoordinates: {
            handler() {
                this.render();
            },
            deep: true
        },

    },
    methods: {
        render() {
            const el = this.$refs['plot'];
            el.innerHTML = ''; // clear

            if (this.input && this.input.exon_sumstats) {

                const exon_index = _.chain(this.input.exon_sumstats.exon_index)
                    .flatMap(index =>
                        _.chain(this.input.transcript_anno.exon_index)
                            .reduce((indices, val, i) => val === index ? indices.concat(i) : indices, [])
                            .map(i => (this.input.transcript_anno.start[i] + this.input.transcript_anno.end[i]) / 2)
                            .value()
                    ).value();

                const beta = this.input.exon_sumstats.beta;
                const ci = this.input.exon_sumstats.ci;


                const margin = {top: 40, right: 30, bottom: 30, left: 60}, // changed the top margin to fit the plot title 
                    width = 1000 - margin.left - margin.right,
                    height = 200 - margin.top - margin.bottom;

                const svg = d3.select(el)
                    .append("svg")
                    .attr("width", width + margin.left + margin.right)
                    .attr("height", height + margin.top + margin.bottom)
                    .append("g")
                    .attr("transform", `translate(${margin.left}, ${margin.top})`);

                const x = d3.scaleLinear()
                    .domain([0, this.meta.x_limit])
                    .range([ 0, width ]);

                svg.append("g")
                    .attr("transform", `translate(0, ${height})`)
                    .call(d3.axisBottom(x));

                const y = d3.scaleLinear()
                    .domain([_.min(beta) - _.max(ci), _.max(beta) + _.max(ci)])
                    .range([ height, 0 ]);

                svg.append("g")
                    .call(d3.axisLeft(y).ticks(5));

                // zero
                svg.append('line')
                    .attr('x1', 0)
                    .attr('x2', width)
                    .attr('y1', y(0))
                    .attr('y2', y(0))
                    .style('stroke', 'lightgrey')
                    .style('stroke-width', '1px');


                // Create circles, whiskers, and notches for each data point
                exon_index.forEach((x_val, i) => {
                    const y_val = beta[i];
                    const ci_val = ci[i];

                    // Create whiskers
                    svg.append('line')
                        .attr('x1', x(x_val))
                        .attr('x2', x(x_val))
                        .attr('y1', y(y_val - ci_val))
                        .attr('y2', y(y_val + ci_val))
                        .style('stroke', 'grey')
                        .style('stroke-width', '1px');

                    // Create notches
                    const notchWidth = 10;
                    svg.append('line')
                        .attr('x1', x(x_val) - notchWidth / 2)
                        .attr('x2', x(x_val) + notchWidth / 2)
                        .attr('y1', y(y_val - ci_val))
                        .attr('y2', y(y_val - ci_val))
                        .style('stroke', 'grey')
                        .style('stroke-width', '1px');
                    svg.append('line')
                        .attr('x1', x(x_val) - notchWidth / 2)
                        .attr('x2', x(x_val) + notchWidth / 2)
                        .attr('y1', y(y_val + ci_val))
                        .attr('y2', y(y_val + ci_val))
                        .style('stroke', 'grey')
                        .style('stroke-width', '1px');

                    // Create circle
                    svg.append('circle')
                        .attr('cx', x(x_val))
                        .attr('cy', y(y_val))
                        .attr('r', 3)
                        .style('fill', 'lightblue')
                        .style('stroke', 'royalblue')
                        .style('stroke-width', '1px');
                });



                // Add title to ExonSumStats plot
                svg.append('text')
                    .attr('x', 140)
                    .attr('y', -10) 
                    .style('text-anchor', 'end')
                    .style('font-size', '14px')
                    .style('font-weight', 'bold')
                    .style('fill', '#333333')
                    .text("Exon-level effect sizes");

                // Add facet label
                svg.append("rect")
                    .attr("x", width)
                    .attr("y", 0)
                    .attr("width", 75)
                    .attr("height", height)
                    .style("fill", "#f0f0f0");

                svg.append('text')
                    .attr("x", 0)
                    .attr("y", 0)
                    .attr('text-anchor', 'middle')
                    .attr('transform', `translate(${width+20},${height/2}) rotate(-90)`)
                    .style('font-size', '16px')
                    .text('β with 95% CI');

                // Left label
                svg.append('text')
                    .attr('transform', `translate(-30, ${height / 2}) rotate(-90)`)
                    .style('text-anchor', 'middle')
                    .style('font-size', '16px')
                    .text('Effect size');
                
                // Checks if the quantification method is 'leafcutter' and there are line coordinates available. 
                // If True, it calls `drawVerticalLines` to render vertical lines on the SVG element.
                if (this.lineCoordinates.length && this.meta.quant_method === "leafcutter") {
                    drawVerticalLines(svg, x, height, this.lineCoordinates)
                }
                
       
            }
        }
    }
}
</script>

<style scoped>

</style>